import React from "react";
import { Check, Minus } from "lucide-react";
import { COMPARE_GROUPS, PLAN_ORDER, PLAN_META, compareCell } from "@/lib/plans";

// Full plan comparison table, grouped by product area (Resume Builder,
// Improve/Optimize, Job Match, AI Style Studio, Downloads & sharing, Job
// search & LinkedIn). Shared by the paywall and the landing pricing section
// so both always show the same, live, enforced numbers.
export function PlanCompare({ quotas, isLight, plans = PLAN_ORDER }) {
  const head = isLight ? "text-slate-900" : "text-white";
  const muted = isLight ? "text-slate-500" : "text-[#9FB8AC]";
  const line = isLight ? "border-slate-200" : "border-white/10";
  const cell = (v) =>
    v === true ? <Check className="mx-auto size-4 text-[#22C55E]" aria-label="Included" />
      : v === false ? <Minus className={`mx-auto size-4 ${isLight ? "text-slate-300" : "text-white/25"}`} aria-label="Not included" />
      : <span className={`text-xs font-semibold ${head}`}>{v}</span>;
  return (
    <div className="overflow-x-auto" data-testid="plan-compare">
      <table className="w-full min-w-[560px] text-left text-sm">
        <thead>
          <tr className={`border-b ${line}`}>
            <th className="py-2 pr-3" />
            {plans.map((p) => (
              <th key={p} className={`py-2 px-2 text-center text-xs font-black uppercase tracking-wider ${PLAN_META[p].recommended ? "text-[#A67C52]" : head}`}>{PLAN_META[p].name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {COMPARE_GROUPS.map((g) => (
            <React.Fragment key={g.area}>
              <tr><td colSpan={plans.length + 1} className="pt-4 pb-1 text-[11px] font-black uppercase tracking-widest text-[#A67C52]">{g.area}</td></tr>
              {g.rows.map((row) => (
                <tr key={row.label} className={`border-b ${line}`}>
                  <td className={`py-2 pr-3 text-xs ${muted}`}>{row.label}</td>
                  {plans.map((p) => <td key={p} className="py-2 px-2 text-center">{cell(compareCell(row, p, quotas))}</td>)}
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}
